module.exports = __webpack_public_path__ + "img/lg_ring_r_o_null_null.d2290cf8.png";